<template>
  <b-form class="restricted-channel">
    <dyn-slot :slot-data="slotData"><slot name="txtBefore"><div class="col-xs-12 text-left">
      <p>Um Ihre Kundendaten abrufen zu können, senden wir Ihnen einen Zugangscode per SMS an Ihre Vertragsrufnummer oder einen Zugangslink an Ihre bei uns hinterlegte E-Mail-Adresse.</p>
      <p><strong>Die Rufnummer Ihres Vertrages: <app-msisdn :msisdn="msisdn"></app-msisdn></strong></p></div>
    </slot></dyn-slot>
    <b-row>
      <b-col>
        <b-form-radio v-model="channel" value="SMS" v-if="hasOption('SMS')" :state="isValid('channel')"><slot name="txtSMSOption">Ich möchte den Zugangscode per SMS an meine Mobilrufnummer erhalten.</slot></b-form-radio>
        <b-form-radio v-model="channel" value="EMAIL" v-if="hasOption('EMAIL')"><slot name="txtEMailOption">Ich möchte einen Zugangscode per E-Mail an meine im Kundenkonto hinterlegte E-Mail-Adresse erhalten.</slot></b-form-radio>
        <p v-if="!hasOption('EMAIL')" class="custom-radio"><slot name="txtNoEMailOption"><br>Eine Zustellung des Zugangscode per Mail ist leider nicht möglich, da in Ihrem Kundenkonto keine E-Mail-Adresse hinterlegt ist.</slot></p>
      </b-col>
    </b-row>
    <Stepper
      @prev="back()"
      variant-prev="tertiary"
      @next="next()"
      :disabled-next="$v.$invalid || loading"
      :loading-next="loading"
    >
      <template #btnPrev><slot name="btnPrev">zurück</slot></template>
      <template #btnNext><slot name="btnNext">weiter</slot></template>
    </Stepper>
    <slot name="txtAfter">
      <p>
        <br>
        <strong>E-Mail-Adresse aktualisieren</strong>
      </p>
      <p>
        <br>
        Sollte Ihre bei uns hinterlegte E-Mail-Adresse nicht mehr aktuell sein bzw. ist der Login daher nicht möglich, so kontaktieren Sie bitte zwecks Änderung Ihrer E-Mail-Adresse die Kundenbetreuung.
      </p>
    </slot>
  </b-form>
</template>

<script>

import Stepper from '@/components/generic/Stepper.vue'
import { BCol, BRow, BForm } from 'bootstrap-vue'
import processSteps from '@/mixins/processSteps'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import preFilledInput from '@/mixins/preFilledInput'
import { required } from 'vuelidate/lib/validators'

export const stepName = 'queryChannel'

export default {
  name: 'InputChannel',
  components: { Stepper, BCol, BRow, BForm },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    hasOption (type) {
      if (!Array.isArray(this.options)) return false
      return this.options.indexOf(type) >= 0
    },
    async next () {
      this.loading = true
      await this.setChannel({ channel: this.channel, nextStep: this.nextStep })
      this.loading = false
    },
    back () {
      this.changeStep({ step: this.previousStep })
    },
    ...mapActions({
      setChannel: 'setRestrictedLoginChannel'
    }),
    ...mapMutations({
      changeStep: 'changeRestrictedLoginStep'
    })
  },
  computed: {
    ...mapGetters([
      'getRestrictedLoginChannel',
      'getRestrictedLoginChannelOptions',
      'getRestrictedLoginMsisdn'
    ]),
    msisdn () {
      return this.getRestrictedLoginMsisdn
    },
    slotData () {
      return {
        msisdn: this.msisdn,
        loading: this.loading
      }
    }
  },
  mixins: [
    processSteps(stepName, stepName, stepName),
    validationMixin,
    isValid,
    preFilledInput('channel', 'getRestrictedLoginChannel'),
    preFilledInput('options', 'getRestrictedLoginChannelOptions')
  ],
  validations () {
    return {
      channel: {
        required
      }
    }
  }
}
</script>
